import * as React from "react"
import { Link } from "gatsby"
import { styled } from "../styles/stitches.config";

export function SideBar() {

    const SideBar = styled('div', {
        transition: 'transform 0.5s',
        // '&:hover': {
        //   transform: 'translate(360px, 0px)',
        // },
        display: 'flex',
        flexFlow: 'column wrap',
        justifyContent: 'start',
        position: 'absolute',
        padding: '0 48px',
        zIndex: 1000,
        top: 0,
        left: '-100vw',
        width: '360px',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: '#f8f5f1',
        '@bp1': {
            width: '100vw',
        },
        '& .sidebarLink': {
            textTransform: 'uppercase',
            fontFamily: '$lato',
            letterSpacing: '4px',
            lineHeight: '23px',
            fontSize: '14px',
            padding: '22px 0',
            borderBottom: '1px solid #d1d3d6',
        },
    });

    const BlurBackground = styled('div', {
        content: '',
        display: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 99,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,.6)',
    });

    const dismissSidebar = () => {
        document.getElementById('hi').style.transform = "translate(-360px, 0)";
        document.getElementById('background').style.display = "none";
        document.getElementsByTagName('body')[0].style.overflow = "auto";
    };

    return (
        <div>
            <SideBar id="hi">
                <div>
                    <div onClick={() => dismissSidebar()} style={{ margin: '60px 0 120px 0', cursor: 'pointer' }}>
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.4638 10.0053C10.3662 10.0148 10.2733 10.0522 10.1962 10.1129C10.1192 10.1737 10.0612 10.2553 10.0291 10.348C9.99707 10.4408 9.99234 10.5408 10.0155 10.6361C10.0386 10.7315 10.0886 10.8182 10.1596 10.886L19.2785 20.0049L10.1596 29.1159C10.1102 29.1629 10.0706 29.2192 10.0432 29.2816C10.0158 29.3441 10.0011 29.4113 10.0001 29.4795C9.99899 29.5477 10.0115 29.6153 10.037 29.6786C10.0624 29.7419 10.1002 29.7994 10.1481 29.8479C10.196 29.8964 10.2532 29.9348 10.3161 29.9609C10.3791 29.987 10.4467 30.0003 10.5148 30C10.583 29.9997 10.6504 29.9858 10.7132 29.9591C10.7759 29.9323 10.8327 29.8934 10.8801 29.8445L19.9991 20.7255L29.118 29.8445C29.1655 29.8934 29.2222 29.9323 29.285 29.9591C29.3477 29.9858 29.4151 29.9997 29.4833 30C29.5515 30.0003 29.619 29.987 29.682 29.9609C29.745 29.9348 29.8021 29.8964 29.85 29.8479C29.898 29.7994 29.9358 29.7419 29.9612 29.6786C29.9866 29.6153 29.9991 29.5477 29.9981 29.4795C29.997 29.4113 29.9823 29.3441 29.9549 29.2816C29.9275 29.2192 29.888 29.1629 29.8385 29.1159L20.7196 20.0049L29.8385 10.886C29.918 10.8113 29.9716 10.7133 29.9915 10.6061C30.0114 10.499 29.9967 10.3882 29.9494 10.29C29.902 10.1918 29.8246 10.1112 29.7284 10.06C29.6322 10.0088 29.5221 9.98966 29.4142 10.0053C29.3013 10.0216 29.197 10.0751 29.118 10.1574L19.9991 19.2764L10.8801 10.1574C10.8266 10.1025 10.7613 10.0603 10.6893 10.034C10.6172 10.0077 10.5402 9.99788 10.4638 10.0053Z" fill="black"></path>
                        </svg>
                    </div>
                    <div className="sidebarLink"><Link to="/products/multi-active-treatment-essence">Shop</Link></div>
                    <div className="sidebarLink"><Link to="/products/exclusive-gift-set">Gift Set *NEW*</Link></div>
                    <div className="sidebarLink"><Link to="/products/better-days-moon-convos-gua-sha-roller-set">Gua Sha Set *NEW*</Link></div>
                    <div className="sidebarLink"><Link to="/pages/ingredients">Ingredients</Link></div>
                    <div className="sidebarLink"><Link to="/pages/our-story">Our Story</Link></div>
                    <div className="sidebarLink"><Link to="/pages/contact-us">Contact</Link></div>
                </div>
            </SideBar>
            <BlurBackground id="background" onClick={() => dismissSidebar()} />
        </div>
    )
}
